import InstallMobileIcon from '@mui/icons-material/InstallMobile';
import {Box, BoxProps, Button, Card, CardActions, CardHeader, Fade} from '@mui/material';
import {useCallback} from 'react';
import {Translation} from '../i18n/Translation';
import {ComponentWithoutChildren} from '../react/types';
import {useAppInstallFunctions} from './AppInstallFunctions';

export type AppInstallPromptProps = BoxProps;

export const AppInstallPrompt: ComponentWithoutChildren<AppInstallPromptProps> = ({
  ...boxProps
}: AppInstallPromptProps) => {
  const {dismissPrompt, installApp, installOutcome} = useAppInstallFunctions();
  const showPrompt = !!installApp && !installOutcome;
  const install = useCallback(() => {
    void installApp!();
  }, [installApp]);
  return (
    <Fade in={showPrompt} unmountOnExit>
      <Box {...boxProps}>
        <InstallCard dismiss={dismissPrompt} install={install} />
      </Box>
    </Fade>
  );
};

interface InstallCardProps {
  dismiss: () => void;
  install?: () => void;
}

const InstallCard: ComponentWithoutChildren<InstallCardProps> = ({dismiss, install}: InstallCardProps) => {
  return (
    <Card sx={{backgroundColor: (theme) => theme.palette.action.hover, pr: 1.5, py: 1}}>
      <Translation keys={['main:pwa.prompt.title', 'main:pwa.prompt.subheader']}>
        {([title, subheader]) => (
          <CardHeader
            avatar={<InstallMobileIcon color="primary" />}
            slotProps={{title: {variant: 'body1'}}}
            subheader={subheader}
            title={title}
          />
        )}
      </Translation>
      <CardActions sx={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end'}}>
        <Translation keys={['common:button.notNow']}>
          {(text) => (
            <Button onClick={dismiss} variant="text">
              {text}
            </Button>
          )}
        </Translation>
        <Translation keys={['common:button.install']}>
          {(text) => (
            <Button onClick={install} variant="contained">
              {text}
            </Button>
          )}
        </Translation>
      </CardActions>
    </Card>
  );
};
